// App.js or your main routing file
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PopupForm from "./components/PopupForm";
import ThankYouPage from "./components/ThankYouPage";
import { useState } from "react";

function App() {
  const [showPopup, setShowPopup] = useState(true); // Or your logic to show popup

  return (
    <Router>
      <div className="App">
        {/* Your main website content */}
        
        {showPopup && <PopupForm onFormSubmit={setShowPopup} />}
        
        <Routes>
          <Route path="/thank-you" element={<ThankYouPage />} />
          {/* Your other routes */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;